import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createTheme, ThemeProvider } from '@mui/material';
import { useTheme } from 'styled-components';
import { BrowserRouter, MemoryRouter } from 'react-router-dom';
import Contexts from './contexts';
import { initApis, initApis11 } from './common/apis';
import Provider from './provider';


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

initApis11();
root.render(
  <React.StrictMode>
     <MemoryRouter>
     <Contexts>
      <Provider>
      <App />
      </Provider>
      </Contexts>
      </MemoryRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();


